export const CONFIRM_KEYS = ["Enter", "Tab", " "];
export const REMOVE_KEYS = ["Backspace"];
